import * as React from 'react';
import classnames from 'classnames';
import sortBy from 'lodash/sortBy';

import TileStandardContext from '../../context/TileStandardContext';
import TileStandardContentChannelsResidualIcon from './icon/TileStandardContentChannelsResidualIcon';

import { getResidualTabData } from '../../utils/tile-standard';

import '../tile-standard-content-channels.scss';
import './tile-standard-content-channels-residual.scss';

const TileStandardContentChannelsResidual = React.memo<{}>((): JSX.Element => {
  const content = React.useContext(TileStandardContext);
  const data = content ? getResidualTabData(content.channels) : [];
  const sortedData = sortBy(data, 'type');

  const containerClasses = classnames(
    'tile-standard-content-channels',
    'tile-standard-content-channels-residual'
  );

  return (
    <div className={containerClasses}>
      {
        sortedData.map(item => {
          const username = item.username;
          const url = item.url;

          return (
            <div
              key={`tile-standard-content-channels--${String(item.type)}`}
              className="tile-standard-content-channels-residual__item"
            >
              <TileStandardContentChannelsResidualIcon
                type={item.type}
                url={url}
              />
              <div className="tile-standard-content-channels-residual__user text-overflow-ellipsis">
                <a
                  href={url ?? undefined}
                  target="_blank"
                  rel="noopener noreferrer"
                  title={username || url || undefined}
                  className="tile-standard-content-channels-residual__link"
                >
                  {
                    username
                      ? `@${username}`
                      : url
                  }
                </a>
              </div>
            </div>
          );
        })
      }
    </div>
  );
});

export default TileStandardContentChannelsResidual;
